import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';

const SwitchToggle = ({
  label,
  checked,
  onChange,
  labelPlacement = 'end',
  disabled = false,
  size = 'medium',
}) => (
  <FormControlLabel
    control={(
      <Switch
        checked={checked}
        onChange={(e, ch) => onChange(ch)}
        disabled={disabled}
        size={size}
        sx={{
          '& .MuiSwitch-switchBase': {
          },
          '& .MuiSwitch-thumb': {
            boxShadow: 'none',
          },
          '& .MuiSwitch-track': {
            backgroundColor: checked ? '#000' : '#eee',
            border: '1px solid black',
            opacity: 1,
          },
        }}
      />
    )}
    label={label}
    labelPlacement={labelPlacement}
  />
);

export default SwitchToggle;
